import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

import { range } from '@utils/utils';

import styles from './Ellipsis.module.scss';

const THEMES: { [x: string]: string } = {
  default: '',
  dark: 'darkTheme',
};

const Ellipsis: FC<{ amount?: number; identifier?: string }> = ({
  amount = 4,
  identifier = 'key',
}) => {
  return (
    <div className={styles.ellipsis}>
      {range(amount).map((idx) => (
        <div key={`${identifier}--${idx}`} className={styles.ellipse}></div>
      ))}
    </div>
  );
};

const EllipsisContainer: FC<PropsWithChildren<{ theme?: string }>> = ({
  children,
  theme = 'default',
}) => {
  return (
    <div className={classNames(styles.ellipsisContainer, styles?.[THEMES?.[theme]] || undefined)}>
      {children}
    </div>
  );
};

export { EllipsisContainer };
export default Ellipsis;
